import InviraUserShow from './InviraUserShow.vue'
export {InviraUserShow}
export default InviraUserShow

